








































































































































































import { Component, Vue } from "vue-property-decorator";
import DxChart, { DxSeries, DxTooltip } from "devextreme-vue/chart";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import productoModule from "@/store/modules/producto-module";
import pedidoModule from "@/store/modules/pedido-module";
import { producto } from "@/shared/dtos/producto";
type VentaDetallada = {
  fecha: string;
  producto: string;
  cantidad: number;
  precio_unitario: number;
  total: number;
};

@Component({ components: { DxChart, DxSeries, DxTooltip } })
export default class InformeVentas extends Vue {
  ventasDetalladas: VentaDetallada[] = [];
  headersVentas = [
    { text: "Fecha", value: "fecha" },
    { text: "Producto", value: "producto" },
    { text: "Coste", value: "coste" },
    { text: "Total", value: "total" },
    { text: "Ganancia", value: "ganancia" },
  ];

  ticketPromedio = 0;
  tasaCrecimiento = 0;
  roi = 0;
  puntoEquilibrio = 0;

  comparativaAnual: { anio: string; ventas: number }[] = [];
  comparativaMensual: { mes: string; ventas: number }[] = [];
  ticketPromedioMensual: { mes: string; ticket: number }[] = [];

  mounted() {
    this.generarInforme();
  }

  async generarInforme() {
    const data = await this.getMockData();
    const productos = data.filter((p) => p.vendido);

    this.ventasDetalladas = productos
      .slice()
      .sort(
        (a, b) =>
          new Date(b.fecha_venta).getTime() - new Date(a.fecha_venta).getTime()
      )
      .map((p) => ({
        fecha: this.formatDate(p.fecha_venta),
        producto: p.asin,
        cantidad: p.qty,
        precio_unitario: p.precio_vendido / p.qty,
        coste: p.coste_compra,
        total: p.precio_vendido,
        ganancia: (p.precio_vendido - p.coste_compra).toFixed(2),
      }));

    const totalIngresos = productos.reduce(
      (sum, p) => sum + p.precio_vendido,
      0
    );
    const totalCostes = productos.reduce((sum, p) => sum + p.coste_compra, 0);
    const totalCantidad = productos.reduce((sum, p) => sum + p.qty, 0);

    this.ticketPromedio = Number((totalIngresos / totalCantidad).toFixed(2));
    this.roi = Number(
      (((totalIngresos - totalCostes) / totalCostes) * 100).toFixed(2)
    );

    const ventasPorMes = this.agruparPorMes(productos);
    const keys = Object.keys(ventasPorMes);
    if (keys.length >= 2) {
      const mesActual = ventasPorMes[keys[keys.length - 1]];
      const mesAnterior = ventasPorMes[keys[keys.length - 2]];
      this.tasaCrecimiento = Number(
        (((mesActual - mesAnterior) / mesAnterior) * 100).toFixed(2)
      );
    }

    const margenPorUnidad = this.ticketPromedio - totalCostes / totalCantidad;

    const costeFijo = 400 + 100 + 80; // PAU, WALLA , TAX
    this.puntoEquilibrio = Number((costeFijo / margenPorUnidad).toFixed(2));

    this.comparativaAnual = this.agruparPorAnio(productos);
    this.calcularTicketPromedioMensual(productos);

    const ventasPorMesGrafica = this.agruparPorMesGrafico(productos);
    this.comparativaMensual = ventasPorMesGrafica.map((dato) => ({
      mes: dato.mes,
      ventas: dato.ventas,
      ganancia: dato.ganancia,
      rentabilidad: dato.rentabilidad,
      neto: dato.ganancia - costeFijo,
    }));
  }

  calcularTicketPromedioMensual(productos: any[]) {
    const resumen = productos.reduce((acc, p) => {
      const date = new Date(p.fecha_venta);
      const mes = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
      if (!acc[mes]) acc[mes] = { total: 0, cantidad: 0 };
      acc[mes].total += p.precio_vendido;
      acc[mes].cantidad += p.qty;
      return acc;
    }, {} as Record<string, { total: number; cantidad: number }>);

    this.ticketPromedioMensual = Object.keys(resumen)
      .sort()
      .map((mes) => ({
        mes,
        ticket:
          resumen[mes].cantidad > 0
            ? parseFloat(
                (resumen[mes].total / resumen[mes].cantidad).toFixed(2)
              )
            : 0,
      }));
  }

  formatDate(date: Date): string {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${d.getFullYear()}`;
  }

  agruparPorMesGrafico(productos: any[]) {
    const res = productos.reduce(
      (
        acc: {
          [key: string]: {
            ventas: number;
            ganancia: number;
            rentabilidad: number;
          };
        },
        p
      ) => {
        const date = new Date(p.fecha_venta);
        const mes = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}`;
        if (!acc[mes]) acc[mes] = { ventas: 0, ganancia: 0, rentabilidad: 0 };
        acc[mes].ventas += p.precio_vendido;
        acc[mes].ganancia += p.precio_vendido - p.coste_compra;
        return acc;
      },
      {} as {
        [key: string]: {
          ventas: number;
          ganancia: number;
          rentabilidad: number;
        };
      }
    );

    // Calcular rentabilidad y ordenar por mes
    return Object.keys(res)
      .sort((a, b) => {
        const [aYear, aMonth] = a.split("-").map(Number);
        const [bYear, bMonth] = b.split("-").map(Number);
        if (aYear !== bYear) return aYear - bYear;
        return aMonth - bMonth;
      })
      .map((mes) => {
        const { ventas, ganancia } = res[mes];
        const rentabilidad =
          ventas > 0 ? Number(((ganancia / ventas) * 100).toFixed(2)) : 0;
        return { mes, ventas, ganancia, rentabilidad };
      });
  }

  agruparPorMes(productos: any[]) {
    const res = productos.reduce((acc: { [key: string]: number }, p) => {
      const date = new Date(p.fecha_venta);
      const mes = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
      acc[mes] = (acc[mes] || 0) + p.precio_vendido;
      return acc;
    }, {} as { [key: string]: number });
    // Ordenar por año y mes
    return Object.keys(res)
      .sort((a, b) => {
        const [aYear, aMonth] = a.split("-").map(Number);
        const [bYear, bMonth] = b.split("-").map(Number);
        if (aYear !== bYear) return aYear - bYear;
        return aMonth - bMonth;
      })
      .reduce((acc: { [key: string]: number }, key) => {
        acc[key] = res[key];
        return acc;
      }, {} as { [key: string]: number });
  }

  agruparPorAnio(productos: any[]) {
    const res = productos.reduce((acc, p) => {
      const year = new Date(p.fecha_venta).getFullYear();
      acc[year] = (acc[year] || 0) + p.precio_vendido;
      return acc;
    }, {});
    return Object.keys(res).map((anio) => ({ anio, ventas: res[anio] }));
  }

  async getMockData() {
    //Recogida de datos
    await datos_adicionales_productoModule.getdatos_adicionales_productos();
    await productoModule.getproductos();
    await pedidoModule.getpedidos();
    return productoModule.productos;
  }
  customizeTooltip(arg: any) {
    const name = arg.seriesName;

    if (name === "Rentabilidad %") {
      return { text: `${arg.value.toFixed(2)} % (Rentabilidad)` };
    } else if (name === "Neto") {
      return { text: `${arg.value.toFixed(2)} € después de gastos` };
    } else {
      return { text: `${arg.value.toFixed(2)} € (${name})` };
    }
  }
}
